
import { defineComponent } from 'vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  inheritAttrs: false,
  props: {
    checked: { type: Boolean },
    id: { type: String, required: true },
  },
  setup(props) {
    const mainStore = useMainStore();

    return {
      mainStore,
      props,
    };
  },
});
